import { axiosAjax } from './common'

export default {
	// get cluster list
	getClusterList(params) {
		return axiosAjax('/network', 'get', params)
	},
	// getcluster list v1 版本
	getClusterListV1(params) {
		return axiosAjax('v1/network/list', 'get', params)
	},
	// add cluster
	addCluster(params) {
		return axiosAjax('/v1/network', 'post', params)
	},
	// delete cluster
	deleteCluster(id) {
		return axiosAjax('/network/' + id, 'delete')
	},
	// get cluster detail
	getClusterDetail(id) {
		return axiosAjax('/v1/network/' + id)
	},
	// change cluster
	changeCluster(params) {
		return axiosAjax('/network/' + params.id, 'patch', { data: params.data })
	},
	// get cluster resource
	getInstancesList(params) {
		return axiosAjax('/resource', 'get', params)
	},
	// 获取某个集群下面的资源 （工作组添加资源）
	getClusterResourceList(params) {
		return axiosAjax(`/v1/network/${params.network_id}/resource`, 'get', { params: params.data })
	},
	// 获取数据库拦截指令列表
	getInterceptsCommand(params) {
		return axiosAjax('/v1/intercepts', 'get', { params: params })
	},
	// 获取一个资源的详细信息
	getDetailResource(id) {
		return axiosAjax('/v1/resource/' + id)
	},
	// 修改一个资源的信息
	patchDetailResource(params) {
		return axiosAjax('/v1/resource/' + params.id, 'patch', params.data)
	},
	// delete cluster resources
	delDetailResource(ids) {
		return axiosAjax('/resource/' + ids, 'delete')
	},
	// batch delete cluster resource
	batchDeleteResource(ids) {
		return axiosAjax('/batch/resource/' + ids, 'delete')
	},
	// add cluster resource
	addClusterResource(params) {
		return axiosAjax('/v1/resource', 'post', params)
	},
	// get agent new version
	updateAgent() {
		return axiosAjax('/check_update')
	},
	// get sharing cluster list
	getSharing(id) {
		return axiosAjax('/network/' + id + '/sharing')
	},
	// 添加分享集群
	addSharing(params) {
		return axiosAjax('/network/' + params.id + '/sharing', 'patch', { data: params.data })
	},
	// 取消分享集群
	cancelShareCluster(id) {
		return axiosAjax('/network/' + id, 'delete')
	},
	// 添加日志过滤
	addLogFilter(params) {
		return axiosAjax('/log_filter', 'post', params)
	},
	// 删除某个日志过滤条件
	delLogFilter(id) {
		return axiosAjax('/log_filter/' + id, 'delete')
	},
	// 批量删除日志过滤条件
	batchDelLogFilter(ids) {
		return axiosAjax('/batch/log_filter/' + ids, 'delete')
	},
	// 获取安全模式审核人列表
	getSafeApprover(params) {
		return axiosAjax('/account', 'get', { params: params })
	},
	// 添加拦截指令
	addIntercept(params) {
		return axiosAjax('/need_intercept_command/batch', 'post', params)
	},
	// 删除拦截指令
	deleteIntercept(ids) {
		return axiosAjax('/need_intercept_command/batch/' + ids, 'delete')
	},
	// 删除拦截告警指令
	deleteAlarmIntercept(ids) {
		return axiosAjax('/need_intercept_command/batch_notice/' + ids, 'delete')
	},
	// 扫描导入开始
	scanImportStart(params) {
		return axiosAjax('/service_discovery_start', 'get', { params: params })
	},
	// 扫描导入轮询
	scanImportQuery(params) {
		return axiosAjax('/service_discovery_query', 'get', { params: params })
	},
	// 扫描时批量导入资源
	postBatchResource(params) {
		return axiosAjax('/batch/resource', 'post', { data: params })
	},
	// 云账号导入主机
	cloudImportECS(params) {
		return axiosAjax('/network/load_ecs_from_ak', 'post', { data: params })
	},
	// 云账号导入RDS
	cloudImportRDS(params) {
		return axiosAjax('/network/load_rds_from_ak', 'post', { data: params })
	},
	// 测试连通性
	testConnection(params) {
		return axiosAjax('/service_connection_test', 'get', { params: params })
	},
	// 轮询测试联通性
	queryTestConnection(params) {
		return axiosAjax('/query_service_connection_test', 'get', { params: params })
	},
	// 新版轮询扫描导入
	getNewAgentQuery(params) {
		return axiosAjax('/service_discovery_query_v1', 'get', { params: params }, true)
	},
	// 测试key可用性
	testKeyAvaliable(params) {
		return axiosAjax('/resource/' + params.id + '/test_autologin', 'get', { params: params.params })
	},
	// 测试可以可用性轮询
	queryTestAvaliable(params) {
		return axiosAjax('/resource/' + params.id + '/test_autologin_query', 'get', { params: params.params })
	},
	// xlsx表格批量导入
	xlsxBatchImport(params) {
		return axiosAjax('/file/batch/resource', 'post', { data: params })
	},
	// 获取集群中全部资源连接次数统计
	getClusterResourceStatistic(params) {
		// return axiosAjax('/statistic/network_project', 'GET', {params: params})
		// 接口优化，更改为v1版本
		return axiosAjax('/statistic/network_project_v1', 'GET', { params: params })
	},
	// 获取集群中network连接次数统计
	getClusterStatistic(params) {
		// return axiosAjax('/statistic/network', 'GET', {params: params})
		// 接口优化 更改为v1版本
		return axiosAjax('/statistic/network_v1', 'GET', { params: params })
	},
	// 获取资源组统计
	getResourceStatistic(params) {
		// return axiosAjax('/statistic/project', 'GET', {params: params})
		// 接口优化 更改为v1版本
		return axiosAjax('/statistic/project_v1', 'GET', { params: params })
	},
	// 上传sshkey
	uploadSshkey(params) {
		return axiosAjax('/resource/' + params.resourceId + '/autologin', 'post', { data: params.data })
	},
	// 轮询上传sshkey
	queryUploadSshkey(params) {
		return axiosAjax('/resource/' + params.resourceId + '/autologin_query', 'get', { params: params.params })
	},
	// 获取ecs 实例详情
	getEcsAliyunInfo(params) {
		return axiosAjax('/resource/' + params.id + '/aliyun/ecs', 'get', { params: params.params })
	},
	// 批量删除在线用户
	batchDelOnlineUser(params) {
		return axiosAjax('/tunnel_connection/delete_all', 'post', { data: params })
	},
	// 获取云平台区域列表
	getCloudRegions(params) {
		return axiosAjax(`/network/regions/${params.source}/${params.language}`, 'get')
	},
	// 云平台扫描ecs
	scanInstance(data) {
		return axiosAjax('/network/get_instance_list', 'post', { data })
	},
	// 导入扫描到的实例
	loadInstance(data) {
		return axiosAjax('/network/load_instances', 'post', { data })
	},
	// 获取资源列表
	getResourceList(params) {
		return axiosAjax('/resource/list', 'get', { params })
	},
	// 导出集群配置文件
	exportClusterConfig(params) {
		return axiosAjax('/agent/config/export', 'get', {params})
	},
	// 导入集群配置文件
	importClusterConfig(params) {
		return axiosAjax('/agent/config/import', 'post', { data: params })
	},
	// 轮询导入导出结果
	pollingClusterConfig(params) {
		return axiosAjax('/agent/config/query', 'get', { params })
	},
}



// WEBPACK FOOTER //
// ./src/api/cluster.js